import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin } from '../aiSuggestionsPluginType';
import { thinkingPluginKey } from '../pm-plugins/thinking-plugin';

import type { CompleteThinkingAction } from './types';

export const completeThinkingAction: (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
) => CompleteThinkingAction =
	(api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined) => (): boolean => {
		return (
			api?.core?.actions.execute(({ tr }) => {
				tr.setMeta(thinkingPluginKey, {
					status: 'complete',
				});
				return tr;
			}) || false
		);
	};
